import { useEffect, useState } from "react";

const STORAGE_KEY = "camerasToCompare";

export const useCameraComparison = (allCameras) => {
  const cameraList = allCameras;
  const [active, setActive] = useState(false);
  const [hidden, setHidden] = useState(true);
  const [selectedCameras, setSelectedCameras] = useState([]);
  const [cameraCount, setCameraCount] = useState(0);
  const [slideState, setSlideState] = useState("");

  useEffect(() => {
    const result = window.localStorage.getItem(STORAGE_KEY);

    if (Array.isArray(result) && result.length) {
      setSelectedCameras(result);
      setCameraCount(result.length);
    }
  }, []);

  const toggleComparison = () => setActive((current) => !current);

  const addCamera = (cameraId) => {
    const newCamera = cameraList.find(({ id }) => id === cameraId);

    if (!newCamera) {
      return;
    }

    setSelectedCameras((currentList) => {
      const newList = [...currentList, newCamera];

      window.localStorage.setItem(STORAGE_KEY, newList);

      setCameraCount(newList.length);

      return newList;
    });
  };

  const removeCamera = (cameraId) => {
    setSelectedCameras((currentList) => {
      const newList = [
        ...currentList.filter(({ id }) => id !== cameraId)
      ];

      if (newList.length === 0) {
        setSlideState("hide");
        window.localStorage.removeItem(STORAGE_KEY);
        setActive(false);
      } else {
        window.localStorage.setItem(STORAGE_KEY, newList);
      }

      setCameraCount(newList.length);

      return newList;
    });
  };

  useEffect(() => {
    if (!cameraCount) {
      setTimeout(() => {
        setHidden(true);
      }, 400);
      return;
    }

    if (cameraCount && hidden) {
      setHidden(false);
      setSlideState("show");
    }
  }, [cameraCount]);

  const comparisonContext = {
    active,
    hidden,
    selectedCameras,
    cameraCount,
    withComparison: true,
    toggleComparison,
    addCamera,
    removeCamera,
    slideState,
    setSlideState
  };

  return comparisonContext;
};
